<template>
  <div class="tw:flex tw:items-start tw:gap-2">
    <!-- Added v-if to make the label optional -->
    <span
      v-if="!props.hideLabel"
      class="tw:text-sm tw:font-semibold tw:whitespace-nowrap tw:pt-[0.25em]"
    >
      {{ getLocaleText("sentiment_widget.sentiment_rating") }}
    </span>

    <BaseButtonDropdown
      bordered
      chevron
      class="tw:flex-1 tw:relative"
      close-on-click
      :flip="false"
      :icon="props.selectedOption?.icon"
      :icon-class="props.selectedOption?.iconClass"
      :label="
        props.selectedOption?.label ??
        getLocaleText('sentiment_widget.sentiment_rating')
      "
      new-design
      new-dropdown
      new-icon
      :offset="[0, 0]"
      placement="bottom-start"
      same-width-popper
    >
      <button
        v-for="option in props.options"
        :key="option.field"
        class="tw:flex tw:items-center tw:gap-1 tw:py-2 tw:px-4 tw:text-[13px] tw:leading-[18px] tw:w-full tw:text-left tw:bg-transparent tw:border-0 tw:cursor-pointer"
        :class="
          option.field === props.selectedOption?.field
            ? 'tw:bg-denim-200 tw:font-semibold'
            : 'tw:hover:bg-denim-100'
        "
        data-testid="sentiment-rating-dropdown-option"
        type="button"
        @click="onSelect(option)"
      >
        <BaseIcon
          v-if="option.icon"
          class="tw:text-base tw:shrink-0"
          :class="option.iconClass"
          :icon="option.icon"
        />
        <span>{{ option.label }}</span>
      </button>
    </BaseButtonDropdown>
  </div>
</template>

<script setup lang="ts">
import { getLocaleText } from "shared/boot/i18n";
import { BaseButtonDropdown, BaseIcon } from "shared/components/base";
import type { MentionSentimentOption } from "shared/composables/useMentionSentiment";

interface SentimentRatingDropdownProps {
  hideLabel?: boolean;
  options: MentionSentimentOption[];
  selectedOption?: MentionSentimentOption;
}

const props = defineProps<SentimentRatingDropdownProps>();

const emit = defineEmits<{
  select: [option: MentionSentimentOption];
}>();

function onSelect(option: MentionSentimentOption): void {
  emit("select", option);
}
</script>
